<template>
    <div class="cc-attribute-selector">
        <select class="cc-input cc-input--select cc-input--small" :data-group="group.id" @change="selectAttribute">
            <option v-for="attribute in group.values" v-bind:key="attribute.id" :value="attribute.id">{{ attribute.name }}</option>
        </select>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
            }),
        },
        methods: {
            selectAttribute: function (event) {
                const attribute = {
                    attributeId: event.target.value,
                    groupId: event.target.dataset.group,
                };

                this.$emit('selectAttribute', attribute);
            }
        },
        props: [
            'group',
        ],
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/attribute-selector";
</style>
